import { ServiceArea } from "@/api.types";
import { CreateServiceAreaForm } from "./create-service-area-form";
import { useUpdateServiceArea } from "@/api/service-areas";

interface EditServiceAreaFormProps {
  serviceArea: ServiceArea;
  onClose: () => void;
}

export function EditServiceAreaForm({
  serviceArea,
  onClose,
}: EditServiceAreaFormProps) {
  const updateServiceAreaMutation = useUpdateServiceArea({
    onSuccess: () => {
      onClose();
    },
  });

  return (
    <CreateServiceAreaForm
      mode="edit"
      defaultValues={{
        ...serviceArea,
        depotId: serviceArea.depotId,
      }}
      onSubmit={(values) =>
        updateServiceAreaMutation.mutate({
          ...values,
          id: serviceArea.id,
        })
      }
      onCancel={onClose}
    />
  );
}
